import script from "./BranchOption.vue?vue&type=script&lang=ts&setup=true"
export * from "./BranchOption.vue?vue&type=script&lang=ts&setup=true"

import "./BranchOption.vue?vue&type=style&index=0&id=fa79fafa&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa79fafa"]])

export default __exports__